export default __webpack_public_path__ + "static/media/reusing_data.16bd542f.gif";